/**
 * Group Security — client-side gating helpers.
 *
 * NEUTRALIZED for Group Security v3 (spec §5 / §15 D1–D3). v1 had a mutually-exclusive "group mode"
 * where a non-admin became a **scoped member** confined to a single folder — so the UI hid the
 * root "New Folder" / create affordances and auto-landed them into that sole folder. v3 removes the
 * mode: folder access is ADDITIVE (a member sees every folder granted to them, their teams, or their
 * groups — resolved by the §5 additive-OR evaluator), so there is no "one folder" to confine to and
 * no root-create restriction. The concept no longer exists.
 *
 * The hook is kept as a stable no-op so its existing call sites (`hideRootCreate`, `shouldAutoLand`,
 * `isScopedMember` across screens / assets / playlists / schedules / engage) keep compiling and
 * simply stop hiding anything. Backend remains the enforcer for all real access decisions.
 */
export function useGroupSecurityGating() {
  return {
    /** v3: the "scoped member" mode is gone — always false. */
    isScopedMember: false,
    /** v3: root create is never hidden by group security. */
    hideRootCreate: (_atRoot: boolean) => false,
    /** v3: no auto-land — members are not confined to a single folder. */
    shouldAutoLand: (_accessibleRootFolderCount: number, _hasRootItems: boolean) => false,
  };
}
